import { Card, Stack } from "@mui/material";
import Page from "../Page";
import { FEATURE } from "src/util/enums";
import { useAccess } from "src/hooks/useAccess.hook";
import { useList } from "src/hooks/useFetch.hook";
import { BaseTable } from "../BaseTable/BaseTable";
import { customerListColumns } from "./customer.constant";
import { useNavigate } from "react-router-dom";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import ExportCSV from "src/components/ExportCsv/ExportCSV";

export default function UserList() {
  const hasCreateAccess = useAccess(FEATURE.CUSTOMERS, "C");
  const { data: customers, isFetching } = useList("customers", true, [{ cmType: "CMS" }]);
  const isReadOnly = useAccess(FEATURE.CUSTOMERS, "R");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState();

  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    dispatch(tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
      detailsId: id,
      tabOpenedFor: "customer",
      tabOpened: "general"
    }))
    navigate(`/customer/${id}`);
  };

  const addNewCustomerBtnHandler = () => dispatch(tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
    detailsId: "",
    tabOpenedFor: "customer",
    tabOpened: "general"
  }))

  useEffect(() => {
    if (!isFetching && Array.isArray(customers)) {
      let data = [...customers];
      setTableData(data);
    } else if (!isFetching) {
      setTableData([]);
    }
  }, [isFetching, customers]);

  const handleSearching = (event) => {
    const dataToSearchFrom = customers || [];
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue && Array.isArray(dataToSearchFrom)) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "firstName",
            "email",
            "phone",
            "active",
            "createdAt",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key, value]) => relevantFields.includes(key))
            .map(([key, value]) => {
              if (key === "createdAt") {
                return yearFirstDateTimeFormat(value).toString()
              } else if (key === "firstName") {
                return (`${currentObj.firstName} ${currentObj.lastName}`).toString().toLowerCase()
              } else {
                return value === "Y" ? "enabled" : value === "N" ? "disabled" : value ? value.toString().toLowerCase() : ""
              }
            }

            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) {
            filteredDataArr = [...filteredDataArr, currentObj];
          }
          return filteredDataArr;
        },
        []
      );
      setTableData(filteredDataArr);
    } else setTableData(Array.isArray(customers) ? [...customers] : []);
  };

  return (
    <Page
      title="Customer | Smart-CMS"
      actions={
        hasCreateAccess
          ? [{
              path: "/customer/new",
              text: "Add Resident",
              icon: "eva:plus-fill",
              action: addNewCustomerBtnHandler,
            }]
          : []
      }
      hasCreateAccess={hasCreateAccess}
    >
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) => handleSearching(e)}
          />
          <ExportCSV
            rows={tableData || []}
            columns={customerListColumns(isReadOnly)}
            csvMorphemes="ev_drivers"
            csvColumns={customerListColumns(isReadOnly)}
          />
        </Stack>
        <BaseTable
          rows={tableData ?? []}
          columns={customerListColumns(isReadOnly)}
          loading={isFetching}
          getRowId={(row) => row.id}
          pageSize={10}
          showExportCsvBtn={false}
          csvMorphemes="ev_drivers"
          csvColumns={customerListColumns(isReadOnly)}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
        />
      </Card>
    </Page>
  );
}
